<template>
  <v-app>

    <v-toolbar
      app
      class="toolbar-gradient"
      dense
      flat
    >
      <!-- <v-toolbar-side-icon v-if="token"></v-toolbar-side-icon> -->
      <v-btn
        @click="showNavigation"
        icon
        v-if="hasPermission('superuser')"
      >
        <v-icon>fa-navicon</v-icon>
      </v-btn>

      <v-chip v-if="environment === 'development'"  color="secondary" text-color="white" class="font-weight-medium">DEV</v-chip>

      <v-toolbar-title shrink>
        <div id="mainNumber" v-if="domain === 'blueyonder'">
          <span class="mainNumberParens">(</span>800<span class="mainNumberParens">)</span> <span class="primary--text">270-9285</span>
        </div>
        <img v-if="domain === 'blueyonder'" src="/static/blueyonder_logo.svg" id="logo2" width="200px" height="64px" class="hidden-xs-only"/>
      </v-toolbar-title>

      <v-layout row id="toolbar" align-center>
        <v-spacer/>

        <v-btn
          id="helpButton"
          class="navigationButton"
          to="/help"
          v-if="domain === 'blueyonder'"
          v-show="token"
          :icon="$vuetify.breakpoint.xs"
          depressed
          flat
          large
        >
          <v-icon class="hidden-sm-and-up">fa-question-circle</v-icon>
          <span class="hidden-xs-only">HELP</span>
        </v-btn>

        <v-btn
          id="renewalButton"
          class="navigationButton"
          to="/okdmv/renewals"
          v-if="domain === 'atmone'"
          v-show="token"
          :icon="$vuetify.breakpoint.xs"
          depressed
          flat
          large
        >
          <v-icon class="hidden-sm-and-up">fa-reply-all</v-icon>
          <span class="hidden-xs-only">RENEWALS</span>
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              id="cardButton"
              class="navigationButton"
              v-on="on"
              depressed
              flat
              large
              :icon="$vuetify.breakpoint.xs"
              :color="($route.name === 'ChargeCard' || $route.name === 'Transactions') ? 'primary' : 'black'"
              v-show="token && terminalsCard.length > 0"
            >
              <v-icon class="hidden-sm-and-up">fa-credit-card</v-icon>
              <span class="hidden-xs-only">CARD</span>
              <v-icon right dark class="hidden-xs-only">fa-caret-down</v-icon>
            </v-btn>
          </template>

          <v-list class="pa-0 ma-0">
            <v-list-tile
              class="menu-tile"
              to="/credit"
              v-if="hasPermission('can_use_virtual_terminal') &&
                terminalsCardCanCharge.length > 0"
            >
              <v-list-tile-title>Payment</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/credit?r=1"
              v-if="hasPermission('can_use_virtual_terminal') &&
                hasPermission('has_recurring_options') &&
                (terminalsCardProcessors.includes(3) || terminalsCardProcessors.includes(6)) &&
                terminalsCardCanCharge.length > 0"
            >
              <v-list-tile-title>Recurring Payment</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/credit?i=1"
              v-if="hasPermission('can_use_virtual_terminal') &&
                hasPermission('has_installment_options') &&
                terminalsCardCanCharge.length > 0 &&
                (terminalsCardProcessors.includes(3) || terminalsCardProcessors.includes(6))"
            >
              <v-list-tile-title>Installment Payment</v-list-tile-title>
            </v-list-tile>

            <v-list-tile class="menu-tile" to="/transactions" v-if="hasPermission('can_view_transactions')">
              <v-list-tile-title>Transactions</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/schedules"
              v-if="hasPermission('can_view_transactions') &&
                hasPermission('has_schedules') &&
                terminalsCardProcessors.includes(6)"
            >
              <v-list-tile-title>Recurring</v-list-tile-title>
              <v-list-tile-sub-title class="body-1 text-xs-right" v-if="terminalsCardProcessors.includes(3)">PNX</v-list-tile-sub-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/pnx_installments"
              v-if="hasPermission('can_view_transactions') &&
                hasPermission('has_installment_options') &&
                terminalsCardProcessors.includes(6)"
            >
              <v-list-tile-title>Installments</v-list-tile-title>
              <v-list-tile-sub-title class="body-1 text-xs-right" v-if="terminalsCardProcessors.includes(3)">PNX</v-list-tile-sub-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/recurring"
              v-if="hasPermission('can_view_transactions') &&
                (hasPermission('has_recurring_options') || (!hasPermission('has_recurring_options') && !hasPermission('has_installment_options'))) &&
                terminalsCardProcessors.includes(3)"
            >
              <v-list-tile-title class="text-no-wrap">Recurring Data</v-list-tile-title>
              <v-list-tile-sub-title class="body-1 text-xs-right" v-if="terminalsCardProcessors.includes(6)">FAPS</v-list-tile-sub-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/plans"
              v-if="hasPermission('can_view_transactions') &&
                hasPermission('has_installment_options') &&
                terminalsCardProcessors.includes(3)"
            >
              <v-list-tile-title>Installment Data</v-list-tile-title>
              <v-list-tile-sub-title class="body-1 text-xs-right" v-if="terminalsCardProcessors.includes(6)">FAPS</v-list-tile-sub-title>
            </v-list-tile>

            <!--
            <v-list-tile
              class="menu-tile"
              to="/tokenize"
              v-if="hasPermission('can_use_virtual_terminal')"
            >
              <v-list-tile-title>Tokenize</v-list-tile-title>
            </v-list-tile>
            -->
          </v-list>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              id="achButton"
              class="navigationButton"
              v-on="on"
              depressed
              flat
              large
              :icon="$vuetify.breakpoint.xs"
              :color="($route.name === 'ChargeACH' || $route.name === 'TransactionsAch') ? 'primary' : 'black'"
              v-show="token && terminalsACH.length > 0"
            >
              <v-icon class="hidden-sm-and-up">subtitles</v-icon>
              <span class="hidden-xs-only">ACH</span>
              <v-icon right dark class="hidden-xs-only">fa-caret-down</v-icon>
            </v-btn>
          </template>

          <v-list class="pa-0 ma-0">
            <v-list-tile
              class="menu-tile"
              to="/ach"
              v-if="hasPermission('can_use_virtual_terminal') &&
                terminalsACHCanCharge.length > 0"
            >
              <v-list-tile-title>Payment</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/ach?r=1"
              v-if="hasPermission('can_use_virtual_terminal') &&
                hasPermission('has_recurring_options') &&
                (terminalsACHProcessors.includes(3) || terminalsACHProcessors.includes(6)) &&
                terminalsACHCanCharge.length > 0"
            >
              <v-list-tile-title>Recurring Payment</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/ach?i=1"
              v-if="hasPermission('can_use_virtual_terminal') &&
                hasPermission('has_installment_options') &&
                terminalsACHCanCharge.length > 0 &&
                (terminalsACHProcessors.includes(3) || terminalsACHProcessors.includes(6))"
            >
              <v-list-tile-title>Installment Payment</v-list-tile-title>
            </v-list-tile>

            <v-list-tile class="menu-tile" to="/ach_transactions" v-if="hasPermission('can_view_transactions')">
              <v-list-tile-title>Transactions</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/ach_schedules"
              v-if="hasPermission('can_view_transactions') &&
                hasPermission('has_schedules') &&
                terminalsACHProcessors.includes(6)"
            >
              <v-list-tile-title>Recurring</v-list-tile-title>
              <v-list-tile-sub-title class="body-1 text-xs-right" v-if="terminalsACHProcessors.includes(3)">PNX</v-list-tile-sub-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/ach_pnx_installments"
              v-if="hasPermission('can_view_transactions') &&
                hasPermission('has_installment_options') &&
                terminalsACHProcessors.includes(6)"
            >
              <v-list-tile-title>Installments</v-list-tile-title>
              <v-list-tile-sub-title class="body-1 text-xs-right" v-if="terminalsACHProcessors.includes(3)">PNX</v-list-tile-sub-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/ach_recurring"
              v-if="hasPermission('can_view_transactions') &&
                (hasPermission('has_recurring_options') || (!hasPermission('has_recurring_options') && !hasPermission('has_installment_options'))) &&
                terminalsACHProcessors.includes(3)"
            >
              <v-list-tile-title>Recurring Data</v-list-tile-title>
              <v-list-tile-sub-title class="body-1 text-xs-right" v-if="terminalsACHProcessors.includes(6)">FAPS</v-list-tile-sub-title>
            </v-list-tile>

            <v-list-tile
              class="menu-tile"
              to="/ach_plans"
              v-if="hasPermission('can_view_transactions') &&
                hasPermission('has_installment_options') &&
                terminalsACHProcessors.includes(3)"
            >
              <v-list-tile-title>Installment Data</v-list-tile-title>
              <v-list-tile-sub-title class="body-1 text-xs-right" v-if="terminalsACHProcessors.includes(6)">FAPS</v-list-tile-sub-title>
            </v-list-tile>

            <!--
            <v-list-tile
              class="menu-tile"
              to="/ach_tokenize"
              v-if="hasPermission('can_use_virtual_terminal')"
            >
              <v-list-tile-title>Tokenize</v-list-tile-title>
            </v-list-tile>
            -->
          </v-list>
        </v-menu>

        <!--
        <v-btn
          depressed
          flat
          v-if="this.token && hasPermission('can_view_transactions')"
          to="recurring"
          :icon="$vuetify.breakpoint.xs"
        >
          <v-icon class="hidden-sm-and-up">schedule</v-icon>
          <span class="hidden-xs-only">REPORTING</span>
        </v-btn>
        -->

        <!--
        <v-btn icon v-if="token">
          <v-badge overlap>
            <span slot="badge">#</span>
            <v-icon>fa-envelope</v-icon>
          </v-badge>
        </v-btn>
      -->

        <v-btn icon to="/profile" v-show="token">
          <v-icon>fa-cog</v-icon>
        </v-btn>

        <v-btn
          id="logoutButton"
          depressed
          flat
          large
          :icon="$vuetify.breakpoint.xs"
          @click="logout"
          v-show="token"
        >
          <v-icon class="hidden-sm-and-up">fa-sign-out</v-icon>
          <span class="hidden-xs-only">LOGOUT</span>
        </v-btn>
      </v-layout>

    </v-toolbar>

    <v-content>
      <Notifications />
      <v-layout row v-if="token && false">
        <span v-if="accountList && accountList.length === 1">{{selectedAccountName}}</span>

        <v-flex xs3 v-if="accountList && accountList.length > 1">
          <v-select name="accounts" v-model="selectedAccountName" :items="accountList"></v-select>
        </v-flex>

        <v-spacer></v-spacer>

        <v-flex xs3>
          <v-text-field
            append-icon="search"
            hide-details
            label="Search"
            single-line
          ></v-text-field>
        </v-flex>
      </v-layout>

      <router-view/>

      <v-dialog v-model="waitModal" maxWidth="500px" elevation-24 style="z-index: 1000;" @keydown.esc.prevent="closeWaitModal()" @input="v => v || closeWaitModal()">
        <v-card>
          <v-card-text class="text-xs-center" fill-height>
            <v-layout row wrap align-center>
              <img src="/static/ripple.gif"/>
              <span class="primary--text headline">Processing</span><span class="title">... please wait</span>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modal" maxWidth="500px" elevation-24 style="z-index: 1000;" @keydown.esc.prevent="closeModal()" @input="v => v || closeModal()">
        <v-card>
          <v-card-text class="text-xs-center" fill-height>
            <v-layout row wrap align-center>
              <v-flex v-if="modalStatus" xs2>
                <v-icon large class="ma-4" v-if="modalStatus==='success'" color="success" @click="closeModal()">fa-check-circle</v-icon>
                <v-icon large class="ma-4" v-if="modalStatus==='info'" color="info" @click="closeModal()">fa-info-circle</v-icon>
                <v-icon large class="ma-4" v-if="modalStatus==='error'" color="error" @click="closeModal()">fa-exclamation-triangle</v-icon>
              </v-flex>
              <v-flex :class="(!modalStatus) ? 'ml-auto mr-auto' : ''" xs10>
                <h2 class="primary--text headline" v-if="modalMessage">{{ modalMessage }}</h2>
                <template v-if="modalMessageDetails">
                  <template v-if="typeof modalMessageDetails !== 'array' && typeof modalMessageDetails !== 'object'">
                    <div class="title" v-if="modalMessageDetails">{{ modalMessageDetails }}</div>
                  </template>
                  <template v-else>
                    <ul :class="(modalMessage === 'Merchant Boarded Successfully') ? 'modalDetails modalBoardingSuccess' : 'modalDetails'"  v-for="(message, i) in modalMessageDetails" :key="i">
                      <li>{{message}}</li>
                    </ul>
                  </template>
                </template>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="modalType==='confirm'">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="modalConfirm();closeModal()">Yes</v-btn>
            <v-btn @click="closeModal()">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-content>

    <v-navigation-drawer
      app
      clipped
      temporary
      v-if="hasPermission('superuser')"
      v-model="navigation"
    >

      <v-divider class="primary"></v-divider>

      <v-list dense expand>
        <v-subheader inset>Admin</v-subheader>

        <v-list-tile ripple to="/merchants">
          <v-list-tile-content>
            <v-list-tile-title>Merchants</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/terminals">
          <v-list-tile-content>
            <v-list-tile-title>Terminals</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/users">
          <v-list-tile-content>
            <v-list-tile-title>Users</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/chargebacks">
          <v-list-tile-content>
            <v-list-tile-title>Chargebacks</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/billings">
          <v-list-tile-content>
            <v-list-tile-title>Billings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/admin/refund">
          <v-list-tile-content>
            <v-list-tile-title>Standalone Refund (Card)</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/admin/ach_refund">
          <v-list-tile-content>
            <v-list-tile-title>Standalone Refund (ACH)</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/admin/reports">
          <v-list-tile-content>
            <v-list-tile-title>Report List</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/admin/permissions">
          <v-list-tile-content>
            <v-list-tile-title>Permission List</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider class="primary"></v-divider>

        <v-subheader inset>FAPS Management</v-subheader>

        <v-list-tile ripple to="/fpg/search">
          <v-list-tile-content>
            <v-list-tile-title>Search</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/fpg/merchants">
          <v-list-tile-content>
            <v-list-tile-title>Merchants</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider class="primary"></v-divider>

        <v-subheader inset>OKDMV Management</v-subheader>

        <v-list-tile ripple to="/okdmv/agencies">
          <v-list-tile-content>
            <v-list-tile-title>Agencies</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/okdmv/renewals">
          <v-list-tile-content>
            <v-list-tile-title>Renewals</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/okdmv/agencies/add">
          <v-list-tile-content>
            <v-list-tile-title>Add Agency</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider class="primary"></v-divider>

        <v-subheader inset>Paynetworx Management</v-subheader>

        <v-list-tile ripple to="/paynetworx/import">
          <v-list-tile-content>
            <v-list-tile-title>Import Merchant</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/paynetworx/funding">
          <v-list-tile-content>
            <v-list-tile-title>Settlement & Funding</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider class="primary"></v-divider>

        <v-subheader inset>Trxservices Management</v-subheader>

        <v-list-tile ripple to="/trxservices/query">
          <v-list-tile-content>
            <v-list-tile-title>General Query</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider class="primary"></v-divider>

        <v-subheader inset>Random Tools</v-subheader>

        <v-list-tile ripple to="/admin/generator">
          <v-list-tile-content>
            <v-list-tile-title>String Generator</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/admin/convertcsv">
          <v-list-tile-content>
            <v-list-tile-title>CSV Convert</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/admin/convertexcel">
          <v-list-tile-content>
            <v-list-tile-title>Excel Convert</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/admin/emaildecode">
          <v-list-tile-content>
            <v-list-tile-title>Email Decode</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile ripple to="/calendar">
          <v-list-tile-content>
            <v-list-tile-title>Calendar</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-divider class="primary"></v-divider>
    </v-navigation-drawer>

    <v-footer height="auto" color="rgba(255, 255, 255, 0.0)">
      <v-layout row align-end justify-end v-if="domain !== 'blueyonder' && domain !== 'okdmv' && domain !== 'atmone'">
        <v-card flat color="rgba(255, 255, 255, 0)">
          <span class="font-weight-medium">Powered by:</span>
          <br/>
          <img src="/static/paynetworx_logo_large_vector_b_w.svg" width="150px"/>
        </v-card>
      </v-layout>
      <v-layout row align-end justify-start v-if="domain === 'blueyonder' && $route.name === 'Login'">
        <v-img src="/static/blueyonder_logo.png" max-width="600px"></v-img>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import Bus from '@/bus'

import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import StoreMixin from '@/store/mixin'
import Notifications from './components/Notifications.vue'

export default {
  mixins: [APIMixin, AuthMixin, StoreMixin],
  components: {Notifications},

  data: function () {
    return {
      menu: ['Payment', 'Transactions'],
      navigation: false,
      waitModal: false,
      modal: false,
      modalMessage: '',
      modalMessageDetails: '',
      modalTimeout: 0,
      modalStatus: '',
      modalConfirm: null,
      modalType: ''
    }
  },

  created () {
    /*
    Bus.$on('openWaitModal', this.openWaitModal)
    Bus.$on('closeWaitModal', this.closeWaitModal)
    Bus.$on('openModal', this.openModal)
    Bus.$on('closeModal', this.closeModal)
    */

    // change favicon based on domain
    if (this.domain === 'blueyonder') {
      // document.querySelector("link[rel='shortcut icon']").href = '/static/blueyondercorp-favicon-ok.png'
      document.querySelector("link[rel*='icon']").href = '/static/blueyondercorp-favicon-ok.png'
    }

    // change manifest.json based on domain
    // for brevity, we're not including the isDesktop function here
    /*
    let iconUrl = isDesktop() ? '/desktop.png' : '/mobile.png'
    let manifest = {
      name: "App name",
      icons: [{ src: iconUrl, sizes: "512x512", type:"image/png" }]
    }
    let content = encodeURIComponent(JSON.stringify(manifest))
    let url = "data:application/manifest+json,"+content
    let element = document.createElement('link')
    element.setAttribute('rel', 'manifest')
    element.setAttribute('href', url)
    document.querySelector('head').appendChild(element)
    */
  },

  beforeDestroy () {
    Bus.$off('openWaitModal')
    Bus.$off('closeWaitModal')
    Bus.$off('openModal')
    Bus.$off('closeModal')
  },

  async mounted () {
    Bus.$on('openWaitModal', this.openWaitModal)
    Bus.$on('closeWaitModal', this.closeWaitModal)
    Bus.$on('openModal', this.openModal)
    Bus.$on('closeModal', this.closeModal)

    try {
      if (this.$route.meta.needsAuth) {
        let valid = await this.checkToken()
        if (valid) {
          this.startIdleWatcher()
        }
      }
      this.setAppReady()
    } catch (err) {
      console.log('ERROR')
      console.log(err)
      // this.$store.commit('logout')
      this.$store.commit('error', new Error('App mounted error, logout'))
      this.stopIdleWatcher()
      this.forceLogout()
    }
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    },
    selectedAccountName: {
      get () {
        return this.accountNameSelected
      },
      set (name) {
        this.$store.commit('selectAccount', name)
      }
    },

    errorMessages () {
      return Object.values(this.$store.state.errors)
    },
    infoMessages () {
      return Object.values(this.$store.state.info)
    },
    successMessages () {
      return Object.values(this.$store.state.successes)
    },
    persistentMessages () {
      return Object.values(this.$store.state.persistentMessages)
    }
  },

  watch: {
    '$route' (to, from) {
      // Site name - Title
      document.title = ('Virtual Terminal ' + to.meta.title) || 'Virtual Terminal'
    }
  },

  methods: {
    showNavigation () {
      this.navigation = true
    },

    openWaitModal (options) {
      this.waitModal = true
    },

    closeWaitModal () {
      this.waitModal = false
    },

    openModal (options) {
      this.modal = true

      // console.log(err.response)
      // if (err.response && err.response.data && err.response.data.hasOwnProperty('error') && err.response.data.error) {
      //   throw
      // }

      if (options.hasOwnProperty('message')) {
        // handle api requests universally
        if (typeof options.message === 'object' && options.message.hasOwnProperty('response') && options.message.response && options.message.response.hasOwnProperty('data') && options.message.response.data && options.message.response.data.hasOwnProperty('error') && options.message.response.data.error) {
          this.modalMessage = options.message.response.data.error
        } else {
          this.modalMessage = options.message
        }
      }
      if (options.hasOwnProperty('messageDetails')) {
        this.modalMessageDetails = options.messageDetails
      }
      if (options.hasOwnProperty('status')) {
        this.modalStatus = options.status
        if (options.status === 'success' && options.persist !== true) {
          this.modalTimeout = setTimeout(this.closeModal, 3000)
        }
      }
      if (options.hasOwnProperty('type')) {
        this.modalType = options.type
      }
      if (options.hasOwnProperty('confirm')) {
        this.modalConfirm = options.confirm
      }
    },

    closeModal () {
      this.modal = false
      this.modalType = ''
      this.modalConfirm = null
      this.modalStatus = 'info'
      this.modalMessage = ''
      this.modalMessageDetails = ''
    },

    logout () {
      this.stopIdleWatcher()
      this.forceLogout()
    },

    setAppReady () {
      this.$store.commit('appReady', true)
      Bus.$emit('appReady')
    }
  }
}
</script>

<style lang="less">
  @import "./assets/less/main.less";
  @background-color: var(--background-color, #CCC);
  @background-hover-color: var(--background-hover-color, #AAA);

  .menu-tile {
    background: var(--v-primary-lighten1);
    color: white;
  }
  .menu-tile:hover {
    background: var(--v-primary-base);
  }
  .v-list__tile--active:hover {
    background: var(--v-secondary-base);
    color: white !important;
  }

  .toolbar-gradient {
    background-image: linear-gradient(86deg, #ffffff 43%, var(--v-secondary-base) 90%, var(--v-secondary-base) 98%);
  }

  .modalBoardingSuccess:nth-child(3) {
    font-weight: 900;
  }

  .modalBoardingSuccess:nth-child(6) {
    margin-top: 1rem;
    font-weight: 900;
  }

  .modalBoardingSuccess:nth-child(7) {
    margin-bottom: 1rem;
    font-weight: 900;
  }

  .modalBoardingSuccess:nth-child(8) {
    color: var(--v-primary-darken4);
  }

  .modalBoardingSuccess:nth-child(9) {
    color: var(--v-primary-darken4);
  }

</style>



// WEBPACK FOOTER //
// src/App.vue